<template>
    <div class="releasebase-search">
        <b-card 
            border-variant="light"
            :header="this.equipment.internal_code_equipment"
            title="Lançamento de Despesas"
            title-tag="strong"
            header-bg-variant="primary"
            header-text-variant="white"
            v-show="mode_release === 'save' || mode_release === 'remove' || mode_release === 'read'"
            >
            <b-card-text>
              <b-form >
                  <input 
                    id="release-id" 
                    type="hidden" 
                    v-model="release.id" 
                    />
                  <b-row>
                      <b-col md="3" sm="12">
                            <b-form-group 
                                label="Operação:" 
                                label-for="release-operation_level_one_id">
                            <b-form-select 
                                id="release-operation_level_one_id"
                                :disabled="mode_release === 'remove' || mode_release === 'read' || mode_release === 'insert'"
                                :state="operationLevelOneState"
                                size="lg"
                                :options="operationslevelones" 
                                v-model="release.operation_level_one_id" />
                            <b-form-invalid-feedback  id="input-live-operation_level_one_id">
                                    Falta Informar a Operação ...                            
                            </b-form-invalid-feedback >
                            </b-form-group>
                        </b-col>
                        <b-col md="2" sm="12">
                            <b-form-group 
                                label="Data de Emissão:" 
                                label-for="release-release_date">
                            <b-form-input 
                                id="release-release_date" 
                                type="date"
                                title="ALT+H (DATA ATUAL)"
                                v-on:keyup.alt.72="setDateToday"
                                v-model="release.release_date" 
                                :state="releaseDateState"
                                :readonly="mode_release === 'remove' || mode_release === 'read' || mode_release === 'insert'"
                                size="lg"
                            />
                                <b-form-invalid-feedback  id="input-live-issue_date">
                                    Falta Informar Data Emissão...                            
                                </b-form-invalid-feedback >
                            </b-form-group>
                        </b-col> 
                        <b-col md="2" sm="12">
                            <b-form-group 
                                label="Nº de Lançamento:" 
                                label-for="release-release_number">
                            <b-form-input 
                                id="release-release_number" 
                                v-model="release.release_number" 
                                :readonly="mode_release === 'remove' || mode_release === 'read' || mode_release === 'insert'"
                                type="number"
                                size="lg"
                                />
                            </b-form-group>
                        </b-col>
                         <b-col md="2" sm="12">
                            <b-form-group label="Valor:" label-for="release-release_value">
                            <b-form-input 
                                id="release-release_value" 
                                v-model="release.release_value" 
                                type="number"
                                size="lg"
                                :state="releaseValueState"
                                :readonly="mode_release === 'remove' || mode_release === 'read' || mode_release === 'insert'"
                                step="0.02"
                                pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                                />
                                <b-form-invalid-feedback  id="input-live-release_value">
                                    Falta Informar o Valor do Lançamento...                            
                                </b-form-invalid-feedback >
                            </b-form-group>
                        </b-col>
                    </b-row>  
                    <b-row>
                        <b-col md="6" sm="12">
                            <b-form-group 
                                label="Fornecedor:" 
                                label-for="release-entity_id">
                            <b-form-select 
                                id="release-entity_id"
                                :disabled="mode_release === 'remove' || mode_release === 'read' || mode_release === 'insert'"
                                :state="entityState"
                                size="lg"
                                :options="entitys" 
                                v-model="release.entity_id" />
                            <b-form-invalid-feedback  id="input-live-entity_id">
                                    Falta Informar o fornecedor ...                            
                            </b-form-invalid-feedback >
                            </b-form-group>
                        </b-col>
                        <b-col md="4" sm="12">
                            <b-form-group label="Forma de Pagamento">
                                <b-form-radio-group
                                    size="lg"
                                    :disabled="mode_release === 'remove' || mode_release === 'read' || mode_release === 'insert'"
                                    v-model="release.settlement_form"
                                    :options="optionsSettlementForm"
                                    :state="stateSettlementForm"
                                    name="release-settlement_form"
                                >
                                    <b-form-invalid-feedback :state="stateSettlementForm">Informe a forma de pagamento</b-form-invalid-feedback>
                                    <b-form-valid-feedback :state="stateSettlementForm"></b-form-valid-feedback>
                                </b-form-radio-group>  
                            </b-form-group>    
                        </b-col>
                    </b-row>   
                    <b-row v-if="release.settlement_form > 1 ">
                         <b-col md="4" sm="12">
                            <b-form-group 
                            label="Condição de Pagamento:" 
                            label-for="release-condition_payment_receipt_id">
                            <b-form-select 
                                id="release-condition_payment_receipt_id"
                                size="lg"
                                :disabled="mode_release === 'remove' || mode_release === 'read' || mode_release === 'insert'"
                                :options="conditionpaymentreceipts" 
                                v-model="release.condition_payment_receipt_id" />
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                         <b-col md="12" sm="12">
                            <b-form-group 
                                label="Observação:" 
                                label-for="release-comments">
                                <b-form-textarea 
                                    id="release-comments"
                                    :rows="2"
                                    :max-rows="6"
                                    size="lg"
                                    v-model="release.comments"
                                    placeholder="" />
                            </b-form-group>
                        </b-col>
                    </b-row>           
            </b-form>
            </b-card-text>
        </b-card>
            <b-card
            border-variant="primary"
            align="center"
            v-show="mode_release === 'save' || mode_release === 'remove' || mode_release === 'read'"
        >
        <b-button-group>
        <b-button 
            pill 
            title="Salvar"  
            size="lg" 
            variant="primary" 
            class="mt-2 mb-2 ml-2 fa fa-save" 
            v-if="mode_release === 'save'"
            @click="savePayment">
        </b-button>
        <b-button 
            pill 
            title="Voltar" 
            size="lg" 
            variant="secondary" 
            class="mt-2 mb-2 ml-2 fa fa-ban"  
            v-if="mode_release === 'remove' || mode_release === 'save' || mode_release === 'read' "
            @click="resetReleasePayment">
        </b-button>
        </b-button-group>
        </b-card>
         <b-card 
            border-variant="light"
            :header="this.equipment.internal_code_equipment"
            title="Lançamento de Receitas"
            title-tag="strong"
            header-bg-variant="primary"
            header-text-variant="white"
            v-show="mode_release_recipe === 'save' || mode_release_recipe === 'remove' || mode_release_recipe === 'read'"
            >
            <b-card-text>
              <b-form >
                  <input 
                    id="release_recipe-id" 
                    type="hidden" 
                    v-model="release_recipe.id" 
                    />
                  <b-row>
                      <b-col md="3" sm="12">
                            <b-form-group 
                                label="Operação:" 
                                label-for="release-recipe-operation_level_one_id">
                            <b-form-select 
                                id="release-recipe-operation_level_one_id"
                                :disabled="mode_release_recipe === 'remove' || mode_release_recipe === 'read' || mode_release_recipe === 'insert'"
                                :state="operationLevelOneStateRecipe"
                                size="lg"
                                :options="operationslevelones" 
                                v-model="release_recipe.operation_level_one_id" />
                            <b-form-invalid-feedback  id="input-live-recipe-operation_level_one_id">
                                    Falta Informar a Operação ...                            
                            </b-form-invalid-feedback >
                            </b-form-group>
                        </b-col>
                        <b-col md="2" sm="12">
                            <b-form-group 
                                label="Data de Emissão:" 
                                label-for="release-recipe-release_date">
                            <b-form-input 
                                id="release-recipe-release_date" 
                                type="date"
                                title="ALT+H (DATA ATUAL)"
                                v-on:keyup.alt.72="setDateTodayRecipe"
                                v-model="release_recipe.release_date" 
                                :state="releaseDateStateRecipe"
                                :readonly="mode_release_recipe === 'remove' || mode_release_recipe === 'read' || mode_release_recipe === 'insert'"
                                size="lg"
                            />
                                <b-form-invalid-feedback  id="input-recipe-live-issue_date">
                                    Falta Informar Data Emissão...                            
                                </b-form-invalid-feedback >
                            </b-form-group>
                        </b-col> 
                        <b-col md="2" sm="12">
                            <b-form-group 
                                label="Nº de Lançamento:" 
                                label-for="release-recipe-release_number">
                            <b-form-input 
                                id="release-recipe-release_number" 
                                v-model="release_recipe.release_number" 
                                :readonly="mode_release_recipe === 'remove' || mode_release_recipe === 'read' || mode_release_recipe === 'insert'"
                                type="number"
                                size="lg"
                                />
                            </b-form-group>
                        </b-col>
                         <b-col md="2" sm="12">
                            <b-form-group 
                                label="Valor:" 
                                label-for="release-recipe-release_value">
                            <b-form-input 
                                id="release-recipe-release_value" 
                                v-model="release_recipe.release_value" 
                                type="number"
                                size="lg"
                                :state="releaseValueStateRecipe"
                                :readonly="mode_release_recipe === 'remove' || mode_release_recipe === 'read' || mode_release_recipe === 'insert'"
                                step="0.02"
                                pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                                />
                                <b-form-invalid-feedback  id="input-recipe-live-release_value">
                                    Falta Informar o Valor do Lançamento...                            
                                </b-form-invalid-feedback >
                            </b-form-group>
                        </b-col>
                    </b-row>  
                    <b-row>
                        <b-col md="6" sm="12">
                            <b-form-group 
                                label="Cliente:" 
                                label-for="release-recipe-entity_id">
                            <b-form-select 
                                id="release-recipe-entity_id"
                                :disabled="mode_release_recipe === 'remove' || mode_release_recipe === 'read' || mode_release_recipe === 'insert'"
                                :state="entityStateRecipe"
                                size="lg"
                                :options="entitys" 
                                v-model="release_recipe.entity_id" />
                            <b-form-invalid-feedback  id="input-recipe-live-entity_id">
                                    Falta Informar o fornecedor ...                            
                            </b-form-invalid-feedback >
                            </b-form-group>
                        </b-col>
                        <b-col md="4" sm="12">
                            <b-form-group label="Forma de Recebimento">
                                <b-form-radio-group
                                    size="lg"
                                    :disabled="mode_release_recipe === 'remove' || mode_release_recipe === 'read' || mode_release_recipe === 'insert'"
                                    v-model="release_recipe.settlement_form"
                                    :options="optionsSettlementForm"
                                    :state="stateSettlementFormRecipe"
                                    name="release_recipe-settlement_form"
                                >
                                    <b-form-invalid-feedback :state="stateSettlementFormRecipe">Informe a forma de recebimento</b-form-invalid-feedback>
                                    <b-form-valid-feedback :state="stateSettlementFormRecipe"></b-form-valid-feedback>
                                </b-form-radio-group>  
                            </b-form-group>    
                        </b-col>
                    </b-row>   
                     <b-row v-if="release_recipe.settlement_form > 1 ">
                         <b-col md="4" sm="12">
                            <b-form-group 
                                label="Condição de Recebimento:" 
                                label-for="release-recipe-condition_payment_receipt_id">
                            <b-form-select 
                                id="release-recipe-condition_payment_receipt_id"
                                size="lg"
                                :disabled="mode_release_recipe === 'remove' || mode_release_recipe === 'read' || mode_release_recipe === 'insert'"
                                :options="conditionpaymentreceipts" 
                                v-model="release_recipe.condition_payment_receipt_id" />
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                         <b-col md="12" sm="12">
                            <b-form-group 
                                    label="Observação:" 
                                    label-for="release-recipe-comments">
                                <b-form-textarea 
                                    id="release-recipe-comments"
                                    :rows="2"
                                    :max-rows="6"
                                    size="lg"
                                    v-model="release_recipe.comments"
                                    placeholder="" />
                            </b-form-group>
                        </b-col>
                    </b-row>           
            </b-form>
            </b-card-text>
        </b-card>
        <b-card
            border-variant="primary"
            align="center"
            v-show="mode_release_recipe === 'save' || mode_release_recipe === 'remove' || mode_release_recipe === 'read'"
        >
        <b-button-group>
        <b-button 
            pill 
            title="Salvar"  
            size="lg" 
            variant="primary" 
            class="mt-2 mb-2 ml-2 fa fa-save" 
            v-if="mode_release_recipe === 'save'"
            @click="saveRecipe">
        </b-button>
        <b-button 
            pill 
            title="Voltar" 
            size="lg" 
            variant="secondary" 
            class="mt-2 mb-2 ml-2 fa fa-ban"  
            v-if="mode_release_recipe === 'remove' || mode_release_recipe === 'save' || mode_release_recipe === 'read' "
            @click="resetReleaseRecipe">
        </b-button>
        </b-button-group>
        </b-card>
        <b-card 
            border-variant="light"
            :header="this.equipment.internal_code_equipment"
            title="Abastecimento"
            title-tag="strong"
            header-bg-variant="primary"
            header-text-variant="white"
            v-show="mode_supply_control === 'save' || mode_supply_control === 'remove' || mode_supply_control === 'read'"
            >
            <b-card-text>
              <b-form >
                  <input 
                    id="supplycontrol-id" 
                    type="hidden" 
                    v-model="supplycontrol.id" 
                    />
                  <b-row>
                        <b-col md="3" sm="12">
                            <b-form-group 
                                 label="Abastecido em:" 
                                label-for="supplycontrol-supply_date">
                                <b-form-input 
                                    id="supplycontrol-supply_date" 
                                    type="date"
                                    v-model="supplycontrol.supply_date" 
                                    :readonly="mode_supply_control === 'remove' || mode_supply_control === 'read' || mode_supply_control === 'insert'"
                                    size="lg"
                                />
                            </b-form-group>
                        </b-col>
                       <b-col md="2" sm="12">
                        <b-form-group 
                            label="KM/H. Último:" 
                            label-for="supplycontrol-control_supply_current">
                        <b-form-input 
                            id="supplycontrol-control_supply_current" 
                            v-model="supplycontrol.control_supply_current" 
                            :readonly="true"
                            type="number"
                            size="lg"
                            />
                            </b-form-group>
                        </b-col>
                        <b-col md="2" sm="12">
                            <b-form-group 
                                label="KM/H.:" 
                                abel-for="supplycontrol-note_control_value">
                            <b-form-input 
                                id="supplycontrol-note_control_value" 
                                v-model="supplycontrol.note_control_value" 
                                :readonly="mode_supply_control === 'remove' || mode_supply_control === 'read' || mode_supply_control === 'insert'"
                                type="number"
                                size="lg"
                                />
                            </b-form-group>
                        </b-col>
                        <b-col md="2" sm="12">
                            <b-form-group 
                                    label="Abastecimento">
                                <b-form-radio-group
                                    size="lg"
                                    :disabled="mode_supply_control === 'remove' || mode_supply_control === 'read' || mode_supply_control === 'insert'"
                                    v-model="supplycontrol.supply_internal"
                                    :options="optionstypecontrolsupply"
                                    name="equipment-supply_internal"
                                ></b-form-radio-group>  
                            </b-form-group>
                        </b-col> 
                    </b-row>  
                    <b-row>
                      <b-col md="2" sm="12">
                            <b-form-group 
                                label="Qtde:" 
                                label-for="supplycontrol-quantity">
                            <b-form-input 
                                id="supplycontrol-quantity" 
                                v-model="supplycontrol.quantity" 
                                :readonly="mode_supply_control === 'remove' || mode_supply_control === 'read' || mode_supply_control === 'insert'"
                                ref="focusEntryItemQuantity"
                                @input="ItemValue"
                                type="number"
                                size="lg"
                                step="0.02"
                                pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                                />
                            </b-form-group>
                        </b-col>
                         <b-col md="2" sm="12">
                            <b-form-group 
                                label="Valor Unitário:" 
                                label-for="supplycontrol-price_unit_value">
                            <b-form-input 
                                id="supplycontrol-price_unit_value" 
                                v-model="supplycontrol.price_unit_value" 
                                 @input="[ItemValue()]"
                                :readonly="mode_supply_control === 'remove' || mode_supply_control === 'read' || mode_supply_control === 'insert'"
                                type="number"
                                size="lg"
                                step="0.04"
                                pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                                />
                            </b-form-group>
                        </b-col>
                        <b-col md="2" sm="12">
                            <b-form-group 
                                label="Valor Total:" 
                                label-for="supplycontrol-total_value">
                            <b-form-input 
                                id="supplycontrol-total_value" 
                                v-model="supplycontrol.total_value" 
                                type="number"
                                size="lg"
                                :readonly= 'true'
                                step="0.02"
                                pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                                />
                            </b-form-group>
                        </b-col>    
                    </b-row>          
            </b-form>
            </b-card-text>
        </b-card>
        <b-card
            border-variant="primary"
            align="center"
            v-show="mode_supply_control === 'save' || mode_supply_control === 'remove' || mode_supply_control === 'read'"
        >
        <b-button-group>
        <b-button 
            pill 
            title="Salvar"  
            size="lg" 
            variant="primary" 
            class="mt-2 mb-2 ml-2 fa fa-save" 
            v-if="mode_supply_control === 'save'"
            @click="saveSupplyControl">
        </b-button>
        <b-button 
            pill 
            title="Voltar" 
            size="lg" 
            variant="secondary" 
            class="mt-2 mb-2 ml-2 fa fa-ban"  
            v-if="mode_supply_control === 'remove' || mode_supply_control === 'save' || mode_supply_control === 'read' "
            @click="resetSupplyControl">
        </b-button>
        </b-button-group>
        </b-card>

        <b-card 
            border-variant="light"
            title="Troca de Pneu "
            title-tag="strong"
            :header="this.equipment.internal_code_equipment"
            header-bg-variant="primary"
            header-text-variant="white"
            v-show="mode_tire_moviment === 'save' || mode_tire_moviment === 'remove' || mode_tire_moviment === 'read'"
            >
            <b-card-text>
              <b-form >
                  <input 
                    id="tiremoviment-id" 
                    type="hidden" 
                    v-model="tiremoviment.id" 
                    />
                  <b-row>
                        <b-col md="3" sm="12">
                            <b-form-group 
                                 label="Troca em:" 
                                label-for="tiremoviment-moviment_date">
                                <b-form-input 
                                    id="tiremoviment-moviment_date" 
                                    type="date"
                                    v-model="tiremoviment.moviment_date" 
                                    :readonly="mode_tire_moviment === 'remove' || mode_tire_moviment === 'read' || mode_tire_moviment === 'insert'"
                                    size="lg"
                                />
                            </b-form-group>
                        </b-col>
                         <b-col md="3" sm="12">
                            <b-form-group 
                                label="Posição do Pneu:" 
                                label-for="tiremoviment-moviment_tire_position_id">
                            <b-form-select 
                                id="tiremoviment-moviment_tire_position_id"
                                :disabled="mode_tire_moviment === 'remove' || mode_tire_moviment === 'read' || mode_tire_moviment === 'insert'"
                                size="lg"
                                :options="tirepositions" 
                                v-model="tiremoviment.moviment_tire_position_id" />
                            </b-form-group>
                        </b-col>
                        <b-col md="2" sm="12">
                            <b-form-group 
                                label="KM/H.:" 
                                abel-for="tiremoviment-control_apoitement">
                            <b-form-input 
                                id="tiremoviment-control_apoitement" 
                                v-model="tiremoviment.control_apoitement" 
                                :readonly="mode_tire_moviment === 'remove' || mode_tire_moviment === 'read' || mode_tire_moviment === 'insert'"
                                type="number"
                                size="lg"
                                />
                            </b-form-group>
                        </b-col>
                        <b-col md="4" sm="12">
                            <b-form-group 
                                    label="Tipo de Pneu">
                                <b-form-radio-group
                                    size="lg"
                                    :disabled="mode_tire_moviment === 'remove' || mode_tire_moviment === 'read' || mode_tire_moviment === 'insert'"
                                    v-model="tiremoviment.type_tired"
                                    :options="optionsType"
                                    name="tiremoviment_type_tired"
                                ></b-form-radio-group>  
                            </b-form-group>
                        </b-col> 
                    </b-row>  
                     <b-row>
                         <b-col md="12" sm="12">
                            <b-form-group 
                                label="Observação:" 
                                label-for="tiremoviment-comments">
                                <b-form-textarea 
                                    id="tiremoviment-comments"
                                    :rows="2"
                                    :max-rows="6"
                                    size="lg"
                                    v-model="tiremoviment.comments"
                                    placeholder="" />
                            </b-form-group>
                        </b-col>
                    </b-row>
                         
            </b-form>
            </b-card-text>
        </b-card>
        <b-card
            border-variant="primary"
            align="center"
            v-show="mode_tire_moviment === 'save' || mode_tire_moviment === 'remove' || mode_tire_moviment === 'read'"
        >
        <b-button-group>
        <b-button 
            pill 
            title="Salvar"  
            size="lg" 
            variant="primary" 
            class="mt-2 mb-2 ml-2 fa fa-save" 
            v-if="mode_tire_moviment === 'save'"
            @click="saveTireMoviment">
        </b-button>
        <b-button 
            pill 
            title="Voltar" 
            size="lg" 
            variant="secondary" 
            class="mt-2 mb-2 ml-2 fa fa-ban"  
            v-if="mode_tire_moviment === 'remove' || mode_tire_moviment === 'save' || mode_tire_moviment === 'read' "
            @click="resetTireMoviment">
        </b-button>
        </b-button-group>
        </b-card>
        

            <b-row v-show="showTable">
              <div class="col-sm-6">
                  <b-form-group> 
                  <input 
                    size="lg" type="text" icon="search" v-model="search" placeholder="Informe a Descrição/Código do Equipamento" class="form-control">                  
                  </b-form-group>
              </div>
             
                <b-col md="12" sm="12"> 
                <transition  name="slide" type="animation" appear>       
                <b-table :busy="isBusy"   class="table-responsive" hover key="slide" striped :items="filteredList" :fields="fields">
                    <template v-slot:cell(actions)="data">
                      <b-button pill title = "Despesas" @click="loadReleasePayment(data.item)" size="sm" variant="outline-danger" class="mr-2 mt-2">
                          <i class="fa fa-minus-square"></i>
                      </b-button>
                      <b-button pill title = "Receitas" @click="loadReleaseRecipe(data.item)" size="sm" variant="outline-success" class="mr-2 mt-2">
                          <i class="fa fa-plus-square"></i>
                      </b-button>
                      <b-button pill title = "Abastecimento" @click="loadSupplyControl(data.item)" size="sm" variant="outline-primary" class="mr-2 mt-2">
                          <i class="fa fa-dashboard"></i>
                      </b-button>
                       <b-button pill title = "Troca de Pneu" @click="loadTireMoviment(data.item)" size="sm" variant="outline-warning" class="mr-2 mt-2">
                          <i class="fa fa-dot-circle-o"></i>
                      </b-button>
                    </template>  
                </b-table>    
                </transition>
                 <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                        pills
                        aria-controls="my-table"
                    ></b-pagination> 
              </b-col>           
              </b-row>
         </div>
    
</template>
    

<script>
import { baseApiUrl,showError } from '@/global'
import axios from 'axios'
var moment = require('moment')

export default {
    name: 'OrderServiceSearch',
    components: { },
    data: function() {
        return {
            mode_release: 'insert',
            mode_release_recipe: 'insert',
            mode_supply_control: 'insert',
            mode_tire_moviment: 'insert',
            release:{},
            release_recipe:{},
            supplycontrol:{},
            tiremoviment:{},
            equipment:{},
            operation_id:null,
            equipments: [],
            operationslevelones:[],
            entitys:[],
            conditionpaymentreceipts: [],
            tirepositions:[],
            search: '',
            showTable: true,
            isBusy: false,
            perPage: 5,
            currentPage: 1,
            fields: [
                    { key: 'internal_code_equipment', label: 'Código', variant: 'primary', sortable: true },
                    { key: 'name_equipment', label: 'Descrição', sortable: true },   
                    { key: 'actions', label: 'Ações', variant: 'light' }
            ],
            optionsSettlementForm: [
                { text: 'Dinheiro', value: 1 },
                { text: 'Cartão', value: 2 },
                { text: 'Transferência', value: 3 },
                { text: 'Boleto', value: 4 },
                { text: 'Outros', value: 5 }
            ], 
            optionstypecontrolsupply: [
                { text: 'Externo', value: 0 },
                { text: 'Interno', value: 1 }
            ], 
            optionsType: [
                { text: 'Novo', value: 0 },
                { text: 'Usado', value: 1 },
                { text: 'Reformado', value: 2 }
            ],
         
        }
    },
     computed: {
        user(){
            return this.$store.state.user
        },
        compan(){
            return this.$store.state.compan
        },
        filteredList() {
              return this.equipments.filter(equipment => {
              return (
                        equipment.internal_code_equipment.toLowerCase().includes(this.search.toLowerCase()) ||
                        equipment.name_equipment.toLowerCase().includes(this.search.toLowerCase())
                    )
                  })
        },
        releaseDateState() {
            return this.release.release_date ? true : false
        },
        releaseValueState() {
            return this.release.release_value > 0 ? true : false
        },
        operationLevelOneState() {
            return this.release.operation_level_one_id ? true : false
        },
        entityState() {
            return this.release.entity_id ? true : false
        },
        stateSettlementForm() {
            return this.release.settlement_form ? true : false
        },
        releaseDateStateRecipe() {
            return this.release_recipe.release_date ? true : false
        },
        releaseValueStateRecipe() {
            return this.release_recipe.release_value > 0 ? true : false
        },
        operationLevelOneStateRecipe() {
            return this.release_recipe.operation_level_one_id ? true : false
        },
        entityStateRecipe() {
            return this.release_recipe.entity_id ? true : false
        },
        stateSettlementFormRecipe() {
            return this.release_recipe.settlement_form ? true : false
        },
        icon() {
            return this.showTable ? "fa-retweet" : "fa-search"
        },
        rows() {
            return this.equipments.length
        }

    },
    methods: {
        setDateToday(){
            this.release = {...this.release,release_date: moment.utc().local().format('YYYY-MM-DD')} 
        },
        setDateTodayRecipe(){
            this.release_recipe = {...this.release,release_date: moment.utc().local().format('YYYY-MM-DD')} 
        },
        ItemValue(){
                return this.supplycontrol.total_value = parseFloat(parseFloat(this.supplycontrol.quantity ? this.supplycontrol.quantity : 0) * (parseFloat(this.supplycontrol.price_unit_value ? this.supplycontrol.price_unit_value : 0))).toFixed(2)
        },
        formatDate (date) {
                return moment.utc(date).format('YYYY-MM-DD')
        },
        loadReleasePayment(equipment, mode_release = 'save') {
                this.mode_release = mode_release
                this.equipment = equipment
                this.release.equipment_id = equipment.id
                this.release.operation_id = 1
                this.showTable = false
                this.loadOperationsLevelOnes()
        },
        loadReleaseRecipe(equipment, mode_release_recipe = 'save') {
                this.mode_release_recipe = mode_release_recipe
                this.equipment = equipment
                this.release_recipe.equipment_id = equipment.id
                this.release_recipe.operation_id = 2
                this.release.operation_id = 2
                this.showTable = false
                this.loadOperationsLevelOnes()
        },
        loadSupplyControl(equipment, mode_supply_control = 'save') {
                this.mode_supply_control = mode_supply_control
                this.equipment = equipment
                this.supplycontrol.equipment_id = equipment.id
                this.supplycontrol.supply_date = moment().format('YYYY-MM-DD') 
                this.showTable = false
                this.setEquipment()
        },
        loadTireMoviment(equipment, mode_tire_moviment = 'save') {
                this.mode_tire_moviment = mode_tire_moviment
                this.equipment = equipment
                this.tiremoviment.moviment_equipment_id = equipment.id
                this.tiremoviment.moviment_date = moment().format('YYYY-MM-DD') 
                this.showTable = false
        },
        resetReleasePayment() {
            this.mode_release = 'insert'
            this.release = {}
            this.showTable = true
        },
        resetReleaseRecipe() {
            this.mode_release_recipe = 'insert'
            this.release_recipe = {}
            this.showTable = true
        },
        resetSupplyControl() {
            this.mode_supply_control = 'insert'
            this.supplycontrol = {}
            this.showTable = true
        },
        resetTireMoviment() {
            this.mode_tire_moviment = 'insert'
            this.tiremoviment = {}
            this.showTable = true
        },
        toggleBusy() {
            this.isBusy = !this.isBusy
        },
        loadEntitys() {
                const url = `${baseApiUrl}/entitys`
                axios.get(url).then(res => {
                    this.entitys = res.data.map(entity => {
                        return { value: entity.id, text: `${entity.name_entity} - ${entity.cnpj_cpf}` }
                        })
                })

        },
        loadequipments() {

            const url = `${baseApiUrl}/equipments`
            axios.get(url).then(res => {
                this.equipments = res.data
                this.isBusy = false
            })
        },
        loadTirePositions() {

            const url = `${baseApiUrl}/tirepositions`
            axios.get(url).then(res => {
             this.tirepositions = res.data.map(tireposition => {
                return { value: tireposition.id, text: tireposition.tire_position_name }
                })
            })
        },
        loadConditionPaymentReceipt() {
        const url = `${baseApiUrl}/conditionpaymentreceipts`
        axios.get(url).then(res => {
            this.conditionpaymentreceipts = res.data.map(conditionpaymentreceipt => {
                return { value: conditionpaymentreceipt.id, text: conditionpaymentreceipt.name_condition_payment_receipt }
                })
            })
        },
        setEquipment() {
            const url = `${baseApiUrl}/equipments/${this.supplycontrol.equipment_id}`
            axios(url).then(res=> (
                this.supplycontrol = {...this.supplycontrol,control_supply_current: res.data.control_maintenance_current}
            )
            )

        },
        loadOperationsLevelOnes() {
        const url = `${baseApiUrl}/operationslevelones/${this.release.operation_id}/operations`
        axios.get(url).then(res => {
            this.operationslevelones = res.data.map(operationslevelone => {
                return { value: operationslevelone.id, text: operationslevelone.name_operation_level_one }
                })
        })
        },
        async savePayment() {

         
                if(!this.compan)
                {
                    this.release.company_id = this.user.company_default
                }else
                {
                    this.release.company_id = this.compan.id
                }
                       
                this.release.user_id = this.user.id  
                   const method = this.release.id ? 'put' : 'post'
                   const id = this.release.id ? `/${this.release.id}` : ''
                   await axios[method](`${baseApiUrl}/releases${id}`, this.release)
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                            this.resetReleasePayment()
                        })
                        .catch(showError)
            },
            async saveRecipe() {

         
                if(!this.compan)
                {
                    this.release_recipe.company_id = this.user.company_default
                }else
                {
                    this.release_recipe.company_id = this.compan.id
                }
                       
                this.release_recipe.user_id = this.user.id  
                   const method = this.release_recipe.id ? 'put' : 'post'
                   const id = this.release_recipe.id ? `/${this.release_recipe.id}` : ''
                   await axios[method](`${baseApiUrl}/releases${id}`, this.release_recipe)
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                            this.resetReleaseRecipe()
                        })
                        .catch(showError)
            },
            async saveSupplyControl() {

         
                if(!this.compan)
                {
                    this.supplycontrol.company_id = this.user.company_default
                }else
                {
                    this.supplycontrol.company_id = this.compan.id
                }
                       
                this.supplycontrol.user_id = this.user.id  
                   const method = this.supplycontrol.id ? 'put' : 'post'
                   const id = this.supplycontrol.id ? `/${this.supplycontrol.id}` : ''
                   await axios[method](`${baseApiUrl}/supplycontrols${id}`, this.supplycontrol)
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                            this.resetSupplyControl()
                        })
                        .catch(showError)
            },
             async saveTireMoviment() {

         
                if(!this.compan)
                {
                    this.tiremoviment.moviment_company_id = this.user.company_default
                }else
                {
                    this.tiremoviment.moviment_company_id = this.compan.id
                }
                       
                this.tiremoviment.user_id = this.user.id  
                   const method = this.tiremoviment.id ? 'put' : 'post'
                   const id = this.tiremoviment.id ? `/${this.tiremoviment.id}` : ''
                   await axios[method](`${baseApiUrl}/tiremoviments${id}`, this.tiremoviment)
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                            this.resetTireMoviment()
                        })
                        .catch(showError)
            },

    },
   mounted() {
        this.loadequipments()
        this.loadConditionPaymentReceipt()
        this.loadEntitys()
        this.loadTirePositions()
        this.showTable = true
    }
}
</script>

<style>

     .releasebase-search {
        font-size: 0.7rem;
    }
    
    .releasebase-search h6{
        font-size: 0.9rem;
    }

    .releasebase-search textarea{
        font-size: 0.8rem;
    }

    .releasebase-search input,label,form{
        font-size: 0.7rem;
    }

    .releasebase-search select{
        font-size: 0.7rem;
    }



    @keyframes slide-in {
    from {transform: translateY(40px);}
    to {transform: translateY(0);}
    }

    @keyframes slide-out {
        from {transform: translateY(0);}
        to {transform: translateY(40px);}
    }

    .slide-enter-active {
    animation: slide-in 1s ease;
        transition: opacity 1s;
    }

    .slide-leave-active {
        animation: slide-out 1s ease;
        transition: opacity 1s;
    }

    .slide-enter, .slide-leave-to{
        opacity: 0;
    }

    .fade-enter, .fade-leave-to{
    opacity: 0;
    }

    .fade-enter-active, .fade-leave-active{
    transition: opacity 1s;
    }

</style>
